// extracted by mini-css-extract-plugin
export default {"tableSection":"IssueTable_tableSection__DL7SE","chatListContainer":"IssueTable_chatListContainer__Qoi4-"};